import { render, staticRenderFns } from "./ManagerGroupsHistoryTicketsPage.vue?vue&type=template&id=ce3c0072"
import script from "./ManagerGroupsHistoryTicketsPage.vue?vue&type=script&lang=js"
export * from "./ManagerGroupsHistoryTicketsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports